import { createStore } from 'vuex';
import user from './modules/user';
import footer from './modules/footer';

export default createStore({
  modules: {
    user,
    footer,
  },
});
